import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TipoProduto } from '../enum/tipo-produto';
import { TokenService } from '../services/token.service';
@Injectable()
export class RouterGuard {
    profileObj: any;
    valor!: any;
    _user: any = null;
    constructor(private tokenService: TokenService, private router: Router) {
        this._user = this.tokenService.getActiveUser();
    }
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        this.valor = next.data;
        if (!this._user) {
            let initials = "VoceControle";
            if (document.location.hostname.includes('localhost'))
                initials = "Local";
            (window as any).open(environment.accessControl + "login?initials=" + initials, "_self");
            return false
        }
        switch (this.valor.product) {
            case TipoProduto.SAUDE:
                if (this._user.healthProfile && this.valor.profileNotAccess && this._user.healthProfile?.statusId == this.valor.profileNotAccess) {
                    this.router.navigate(['/']);
                    return false
                }
                else if (this._user.healthProfile) {
                    return true
                }
                this.router.navigate(['/']);
                return false
                break;
            case TipoProduto.PREVIDENCIA:
                if (this._user.socialSecurityProfile && !this.valor.profileToAccess || this._user.socialSecurityProfile?.statusId == 22) {
                    return true
                } else if (this._user.socialSecurityProfile && this.valor.profileToAccess || this._user.socialSecurityProfile?.statusId == 22) {
                    let go = true;
                    for (let id of this.valor.profileToAccess) {
                        if (this._user.socialSecurityProfile?.statusId == id) {
                            go = true
                            break;
                        } else {
                            go = false
                        }
                    }
                    go ? null : this.router.navigate(['/']);
                    return go;
                }
                else {
                    this.router.navigate(['/']);
                    return false
                }
                break;
            case TipoProduto.SAUDEPREVIDENCIA:
            //Colocar uma lógica aqui
            default:
                return true
                break;
        }
    }
}
